import { createAction } from 'redux-actions';

export const setServiceNowFeedbackUrl = createAction('Feedback/INIT');
export const getServiceNowFeedbackUrl = createAction('Feedback/SELECT');
